<template>
  <CardBase :headerBorder="false">
    <template #header>{{ $route.meta.title }}</template>
    <template #toolbar>
      <router-link
        v-if="userCan('create.asset')"
        :to="{ name: 'AssetCreate' }"
        class="button button--primary poppins"
      >
        <font-awesome-icon :icon="['fas', 'plus-circle']" class="mr-1" />New
        Asset
      </router-link>
    </template>
    <template #content>
      <form class="form form-search" method="get" @submit.prevent="reloadTable">
        <div class="form-search__row">
          <div class="form-search__single">
            <label class="form__label">Search</label>
            <input
              type="text"
              class="form__input"
              placeholder="Asset Name"
              v-model="formData.search"
            />
          </div>
        </div>

        <div class="form-search__action">
          <div class="w-full flex">
            <BaseButton type="submit" buttonClass="secondary"
              >Search</BaseButton
            >
            <BaseButton
              class="mx-2"
              type="button"
              buttonClass="default"
              @click="reset"
              >Reset Search</BaseButton
            >
          </div>
        </div>
      </form>
      <vue-good-table
        :key="tableKey"
        mode="remote"
        theme="polar-bear"
        :rows="tableData.rows"
        :columns="tableData.columns"
        :total-rows="tableData.totalRows"
        :isLoading="tableData.isLoading"
        :sort-options="{
          enabled: false,
        }"
        :pagination-options="{
          enabled: true,
          perPageDropdown: perPageDropdown,
          dropdownAllowAll: false,
          setCurrentPage: tableData.currentPage,
          infoFn: tablePageInfo,
        }"
        styleClass="vgt-table striped bordered"
        @on-page-change="onPageChange"
        @on-per-page-change="onPerPageChange"
      >
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'uuid'">
            <router-link
              v-if="userCan('update.asset')"
              :to="{ name: 'AssetEdit', params: { id: props.row.uuid } }"
              v-tooltip="'Edit ' + props.row.name"
              class="table-action__link mx-2"
            >
              <font-awesome-icon :icon="['fas', 'edit']" />
            </router-link>
            <button
              v-if="userCan('delete.asset')"
              class="table-action__link"
              v-tooltip="'Delete ' + props.row.name"
              @click="deleteItem(props.row.uuid, props.row.name)"
            >
              <font-awesome-icon :icon="['far', 'trash-alt']" />
            </button>
          </span>
        </template>
      </vue-good-table>
    </template>
  </CardBase>
</template>

<script>
import { showListMixin } from "@/mixins/showListMixin";

export default {
  data: () => {
    return {
      tableData: {
        columns: [
          {
            label: "Name",
            field: "name",
          },
          {
            label: "",
            field: "uuid",
            thClass: "vgt-table__action",
            tdClass: "vgt-table__action",
          },
        ],
        sort_by: "name",
        sort_dir: "asc",
      },
    };
  },
  mixins: [showListMixin],
  methods: {
    reset() {
      this.formData.search = "";

      this.tableData.limit = 10;

      if (this.$route.query.search == undefined) {
        this.tableKey++;
      } else {
        this.tableData.currentPage = 1;
        this.$router.push({ name: "AssetList" }).catch(() => {});
      }
    },
    reloadTable() {
      if (this.formData.search && this.formData.search.length < 3) {
        this.$swal({
          position: "bottom-end",
          showConfirmButton: false,
          toast: true,
          timer: 3000,
          timerProgressBar: true,
          title: "Search query must have at least 3 characters",
          icon: "warning",
        });
      } else {
        this.tableData.currentPage = 1;
        this.$router
          .replace({
            query: {
              search: this.formData.search,
              tz: new Date().getTime()
            },
          })
          .catch(() => {});
      }
    },
  },
};
</script>